import React from 'react'
// libs
import moment from 'moment-timezone'
// hooks
import { useCurrentUser } from 'hooks/index'
// views
import {
  MetadataContent,
  MetadataLabel,
  MetadataValue
} from 'components/Modals/PlanItems/components/ActivitiesList/components/Activities/components/ResourceActivity/views'

interface IIncomingProps {
  date: string
}

const CreatedAt: React.FunctionComponent<IIncomingProps> = ({ date }) => {
  const { timezone } = useCurrentUser()

  return (
    <MetadataContent>
      <MetadataLabel>DATE CREATED</MetadataLabel>
      <MetadataValue>
        {moment(date)
          .tz(timezone)
          .format('D/MM/YYYY')}
      </MetadataValue>
    </MetadataContent>
  )
}

export default CreatedAt
